import React, { MouseEventHandler } from 'react';
import { DropdownMenuDivider } from '../DropdownMenu/DropdownMenuDivider';
import { DropdownMenuItem, DropdownMenuItemProps } from '../DropdownMenu/DropdownMenuItem';
import { BaseCheckboxIcon } from '../Checkbox';

export interface SelectOptionProps extends DropdownMenuItemProps {
  hasCheckbox?: boolean;
  divided?: boolean;
  checked?: boolean;
  children?: React.ReactNode;
  onClick?: MouseEventHandler;
  onMouseEnter?: () => void;
}

export const SelectOption = React.forwardRef<HTMLDivElement, SelectOptionProps>(
  (
    {
      hasCheckbox,
      divided,
      selected,
      checked,
      leftIcon,
      ...props
    }: SelectOptionProps,
    ref
  ) => {
    return (
      <>
        {divided && <DropdownMenuDivider />}
        <DropdownMenuItem
          ref={ref}
          leftIcon={hasCheckbox ? undefined : leftIcon}
          left={hasCheckbox && <BaseCheckboxIcon checked={checked} />}
          selected={selected}
          {...props}
        />
      </>
    );
  }
);
